import { animate } from '@angular/animations';
import { style, transition, trigger } from '@angular/animations';
import { state } from '@angular/animations';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { RecurrenceType } from '@app/modules/statements/models/statements.models';
import { StatementsFacade } from '@app/modules/statements/services/statements.facade';

@Component({
  selector: 'sbnb-statements-transactions-scheduled',
  templateUrl: './statements-transactions-scheduled.component.html',
  styles: [
    `
      td.mat-column-name {
        font-weight: bold;
        font-size: 16px;
      }

      td.mat-column-total,
      th.mat-column-total,
      td.mat-column-detailTotal {
        text-align: right !important;
      }

      table {
        width: 100%;
      }

      .element-row td {
        border-bottom-width: 0;
      }
    `,
  ],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatementsTransactionsScheduledComponent implements OnInit {
  public recurringTransactionsState$ = this.statementsFacade.recurringTransactionsState$;

  public displayedColumns = ['type', 'date', 'category', 'description', 'property', 'total'];
  public buttons = [
    {
      id: 'add',
      label: '+ Add Transaction',
    },
  ];

  public recurrenceType = RecurrenceType;

  constructor(
    private statementsFacade: StatementsFacade,
    private router: Router
  ) {
    this.statementsFacade.getRecurringTransactions();
  }

  ngOnInit(): void {}

  onAddTransaction() {
    this.router.navigate(['/operations/statements/transactions/add']);
  }
}
